import React from 'react';
import { Image, Title } from '@landing/ui';

import * as styles from './ProgramItems.module.scss';

export default function ProgramItems({ items }) {
  return (
    <>
      {items.map(({ time, title, subtitle, description, speaker, list }) => (
        <div key={time} className={styles.item}>
          <div className={styles.time}>{time}</div>
          <div className={styles.aboutItem}>
            {title && (
              <Title tag="h3" color="white" className={styles.title}>
                {title}
              </Title>
            )}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            {description && <p className={styles.description}>{description}</p>}
            {list && (
              <ul className={styles.list}>
                {list.map(item => (
                  <li key={item} className={styles.listItem}>
                    {item}
                  </li>
                ))}
              </ul>
            )}
            {speaker && (
              <figure className={styles.speaker}>
                <Image
                  src={speaker.photo}
                  className={styles.speakerPicture}
                  classImage={styles.speakerImg}
                />
                <figcaption className={styles.speakerName}>{speaker.name}</figcaption>
              </figure>
            )}
          </div>
        </div>
      ))}
    </>
  );
}
